import axios from 'axios';
import { API_URL } from 'constants/config';
import ls from 'localstorage-slim';
import Log from 'lib/Log';
// enable global encryption
ls.config.encrypt = true;

// edit form-fields
export const editRegistrationFormField = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/update/registration-dynamic-fields-field`, payload, headers);
  } catch (err) {
    throw new Error(err);
  }
};

// creating form field

export const createRegistrationFormField = async (payload) => {
  try {
    const headers = {
      headers: {
        Authorization: `Bearer ${ls.get('token')}`,
        organisationid: ls.get('orgId'),
      },
    };

    return await axios.post(`${API_URL}/admin/apprenticeship-program/drag-and-drop/registration-dynamic-fields`, payload, headers);
  } catch (err) {
    throw new Error(err);
  }
};

// delete form field
export const removeRegistrationFormField = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/admin/apprenticeship-program/remove/registration-dynamic-field`, payload, { headers });
  } catch (err) {
    Log.error(err);
  }
};

export const cloneRegistrationFormField = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/admin/apprenticeship-program/clone/registration-dynamic-field`, payload, { headers });
  } catch (err) {
    Log.error(err);
  }
};

export const reOrderingRegistrationFormField = async (payload) => {
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/admin/apprenticeship-program/order/registration-dynamic-fields`, payload, { headers });
  } catch (err) {
    Log.error(err);
  }
};

// learner side api
export const getApplicantRegistrationForm = async (payload) => {
  try {
    const headers = {
      headers: {
        // Authorization: `Bearer ${ls.get('token')}`,
        // organisationid: ls.get('orgId'),
      },
    };

    return await axios.get(`${API_URL}/applicant-registration/form/${payload?.orgId}/${payload?.progId}`, payload, headers);
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const saveApplicantRegistrationForm = async (payload) => {
  const { orgId, progId, inputFields } = payload;
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/applicant-registration/${orgId}/${progId}`, { inputFields }, { headers });
  } catch (err) {
    throw err.response?.data || err;
  }
};
